import {
    GET_PARAMETER_BACKUP_REQUEST,
    GET_PARAMETER_BACKUP
} from './constants';
import { getApiActionCreator } from 'helpers/actionHelper';
export const getParameterBackupAction = getApiActionCreator(GET_PARAMETER_BACKUP);
export const parameterBackupRequest = (assetId, fileType) => ({
    type: GET_PARAMETER_BACKUP_REQUEST,
    assetId,
    fileType
});
